export function formatPercentage(value: number | null | undefined) {
  if (value === null) {
    return "N/A";
  }
  if (value === undefined) {
    return "N/A";
  }
  return `${Math.round(value * 100)}%`;
}
